"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WebUtils {
    static isMobile() {
        return /Mobi|Android/i.test(navigator.userAgent);
    }
}
exports.default = WebUtils;
